import { Injector, Type } from '@angular/core';
export function wrapAllMethodsWithLogging(
    instance: any,
    componentName: string,
    injector?: Injector,
    loggingServiceType?: Type<any>
) {
    const proto = Object.getPrototypeOf(instance);
    console.log("proto", proto)
    console.log("componentName", componentName)
    const skipList = [
        'constructor', 'ngOnInit', 'ngOnDestroy', 'ngOnChanges',
        'ngAfterViewInit', 'ngAfterContentInit', 'ngDoCheck',
        'ngAfterViewChecked', 'ngAfterContentChecked'
    ];

    Object.getOwnPropertyNames(proto).forEach((methodName) => {
        if (skipList.includes(methodName)) return;

        const descriptor = Object.getOwnPropertyDescriptor(proto, methodName);

        // skip getters/setters completely — never touch them
        if (!descriptor || descriptor.get || descriptor.set) return;

        const original = descriptor.value;
        if (typeof original !== 'function') return;
        if (original.__isWrapped) return;

        const wrapped = function (this: any, ...args: any[]) {
            // resolve logger: prefer direct injected property, fallback to lazy Injector fetch
            const getLogger = () => {
                if (this.loggingService) return this.loggingService;
                if (injector && loggingServiceType) {
                    try {
                        return injector.get(loggingServiceType);
                    } catch {
                        return null;
                    }
                }
                return null;
            };

            try {
                const result = original.apply(this, args);

                // handles native Promises AND thenables (e.g. Dexie promises)
                if (result && typeof result.then === 'function') {
                    return result.then(
                        (val: any) => val,
                        (error: any) => {
                            getLogger()?.logFunctionError(error, methodName, componentName);
                        }
                    );
                }

                return result;
            } catch (error) {
                getLogger()?.logFunctionError(error, methodName, componentName);
            }
        };

        wrapped.__isWrapped = true;
        Object.defineProperty(proto, methodName, {
            ...descriptor,
            value: wrapped,
        });
    });
}